class CartRecommendations {
  constructor() {
    this.container = document.querySelector('#cart-recommendations-container');
    if (!this.container) return;

    document.addEventListener('cart:updated', () => this.loadRecommendations());
    document.addEventListener('ajaxProduct:added', () => this.loadRecommendations());
    document.addEventListener('cart:open', () => this.loadRecommendations());
    document.addEventListener('cart:opened', () => this.loadRecommendations());

    // Force resize on cart open
    document.addEventListener('cart:opened', () => {
      // const flickityInstance = Flickity.data(document.querySelector('.cart-flickity-slider'));
      // if (flickityInstance) {
      //   flickityInstance.resize();
      // }
    });
  }

  async loadRecommendations() {
    try {
      const cart = await fetch(`${theme.routes.cart}`).then(res => res.json());
      if (!cart.items.length) {
        this.container.innerHTML = '<p>Add products to see recommendations.</p>';
        return;
      }

      let prev = '/'
      if(theme.routes.home != "/"){
        prev = `${theme.routes.home}/`
      }

      const productId = cart.items[0].product_id;
      const sectionId = 'cart-drawer-recommendations';
      const url = `${prev}recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=6`;
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('.cart-fbw-container');

      if (recommendations) {
        this.container.innerHTML = recommendations.outerHTML;
        this.waitForImagesAndInitFlickity();
      } else {
        this.container.innerHTML = '<p>No recommendations available.</p>';
      }
    } catch (error) {
      console.error('Error loading cart recommendations:', error);
      this.container.innerHTML = '<p>Unable to load recommendations.</p>';
    }
  }

  waitForImagesAndInitFlickity() {
    const container = this.container.querySelector('.cart-flickity-slider');
    if (!container) return;

    const images = container.querySelectorAll('img');
    const totalImages = images.length;
    let loadedImages = 0;

    if (totalImages === 0) {
      // this.initializeFlickity(container);
      return;
    }

    const checkAndInit = () => {
      loadedImages++;
      if (loadedImages === totalImages) {
        // this.initializeFlickity(container);
      }
    };

    images.forEach(img => {
      if (img.complete) {
        checkAndInit();
      } else {
        img.addEventListener('load', checkAndInit);
        img.addEventListener('error', checkAndInit);
      }
    });
  }

  // initializeFlickity(container) {
  //   const flkty = new Flickity(container, {
  //     cellAlign: 'left',
  //     contain: true,
  //     prevNextButtons: true,
  //     pageDots: false,
  //     wrapAround: false,
  //     groupCells: true,
  //     draggable: true,
  //   });

  //   // ResizeObserver fallback
  //   if ('ResizeObserver' in window) {
  //     const resizeObserver = new ResizeObserver(() => {
  //       flkty.resize();
  //     });
  //     resizeObserver.observe(container);
  //   }
  // }
}

document.addEventListener('DOMContentLoaded', () => new CartRecommendations());
